import styled from 'styled-components'
import colors from '@settings/styleSettings'

export const Container = styled.div`
  position: relative;
`

export const CloseIcon = styled.div`
  cursor: pointer;
  color: ${colors.strongGray};
  position: absolute;
  top: -20px;
  right: 1px;
`

export const RowGap = styled.div`
  display: flex;
  gap: 16px;
`

export const Section = styled.div`
  margin: 12px 0;
`

export const Area = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const ErrorText = styled.div`
  margin-top: 8px;
  font-size: 13px;
  color: ${colors.strongRed};
`
